module.exports = __webpack_public_path__ + "img/feedback.b238048f.png";